module.exports = __webpack_public_path__ + "img/4.0d0617e5.png";